<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-form @submit.prevent="save">
          <b-row class="mb-4">
            <b-col sm="2">
              <label>Additional Info:</label>
            </b-col>
            <b-col sm="9">
                <b-form-textarea
                    v-model.lazy="current_seminar.SpecialInstructions"
                    type="text"
                    autocomplete="off"
                    id="SpecialInstructions"

                  ></b-form-textarea>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="2">
              <label>Seminar ID:</label>
            </b-col>
            <b-col sm="10">
              <label>{{current_seminar.SeminarID}}</label>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="2">
              <label>Territory:</label>
            </b-col>
            <b-col sm="10">
              <label>{{current_seminar.Territory.TerritoryName}}</label>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="2">
              <label>Mailer 1:</label>
            </b-col>
            <b-col sm="10">
              <label>{{current_seminar.Artwork1.ArtworkName}}</label>
            </b-col>
          </b-row>
          <b-row v-if="current_seminar.IsSplit">
            <b-col sm="2">
              <label>Mailer 2:</label>
            </b-col>
            <b-col sm="10">
              <label>{{current_seminar.Artwork2.ArtworkName}}</label>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="2">
              <label>Vendor:</label>
            </b-col>
            <b-col sm="10">
              <label>{{current_seminar.Vendor.Name}}</label>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="2">
              <label>Ordered By:</label>
            </b-col>
            <b-col sm="10">
              <label>{{current_seminar.Owner.FirstName}} {{current_seminar.Owner.LastName}} <{{current_seminar.Owner.Email1}}></label>
            </b-col>
          </b-row>
          <b-row v-for="seating in current_seminar.Seatings" :key="seating.SeatingID">
            <b-col sm="2">
              <label>Seating:</label>
            </b-col>
            <b-col sm="10">
              <label>{{seating.SeminarType.SeminarTypeName}} on {{seating.DateOfSeating}} at {{seating.Restaurant.Name}}</label>
            </b-col>
          </b-row>
          <CurrentZipEditor :seminar_object="current_seminar" />
          <ContactsListCommunication v-if="type_of_review==='Counts'" />
          <TerritoryContactsListCommunication v-if="type_of_review==='Confirm'" />
        </b-form>
        <!-- </b-card> -->
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ZipRow from "@/components/CustomSubComponents/ZipRow.vue";
import CurrentZipEditor from "@/components/CustomSubComponents/CurrentZipEditor.vue";
import ContactsListCommunication from "@/components/SubListComponents/ContactsListCommunication.vue";
import TerritoryContactsListCommunication from "@/components/SubListComponents/TerritoryContactsListCommunication.vue";
export default {
  name: "SeminarReview",
  props: {
    seminar_object: { type: Object },
    review_type: { type: String },
  },
  components: {
    ZipRow,
    CurrentZipEditor,
    ContactsListCommunication,
    TerritoryContactsListCommunication,
  },
  data() {
    return {
      current_seminar: this.seminar_object,
      type_of_review: this.review_type,
      current_zips: [],
      timer: null,
    };
  },
  computed: {
    ...mapState(["seminar", "territory", "zip", "n_user"]),
  },
  methods: {
    saveManualField: function (event) {
      var _operation = {
        SeminarID: this.current_seminar.SeminarID,
        FieldToSet: event.Field,
        ValueToSet: event.Value,
      };
      this.$store.dispatch("seminar/SaveSeminarField", _operation).then();
    },

  },
  created() {},
  watch: {
    "current_seminar.SpecialInstructions": function (
      newValue
    ) {
     
      if (this.timer) {
        window.clearTimeout(this.timer);
      }
      this.timer = window.setTimeout(() => {
      this.timer = null;
      var _event = {Field: "SpecialInstructions", Value: newValue};
      this.saveManualField(_event);
        //this.filterList2();
      }, 2000);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>